// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c_video__poster-nl2arRQx {\n    width: 100%;\n    height: 100%;\n    background: #444 url(//p0.ifengimg.com/a/2017/0905/4aaeeaf1c8c482bsize20_w700_h530.jpg) center center no-repeat;\n    background-size: 100% 100%;\n    z-index: 2;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n}\n.playerbutton-3F8kBIrK {\n    width: 72px;\n    height: 72px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    background: url('//p0.ifengimg.com/fe/news_detail/images/vIcon_230062a8.png') no-repeat center;\n}\n.narrowWindow-3tfNfZCa {\n    width: 700px !important;\n}\n", ""]);
// Exports
exports.locals = {
	"c_video__poster": "c_video__poster-nl2arRQx",
	"playerbutton": "playerbutton-3F8kBIrK",
	"narrowWindow": "narrowWindow-3tfNfZCa"
};
module.exports = exports;
